import axios from "axios";
import { toast } from 'react-toastify';
import { showLoader, hideLoader } from "../../redux/slice/loaderSlice";

const axiosPrivate = axios.create({
    base_url: process.env.REACT_APP_BASE_URL,
});
axiosPrivate.interceptors.request.use(
    async (config) => {
        const { Store } = await import("../../redux/Store");
        Store.dispatch(showLoader());
        const token = localStorage.getItem('token');
        if (!token) {
            localStorage.clear();
            toast.error("User is not authenticated. Please log in again.", { className: 'toast-error-custom', autoClose: 8000 });
            const lastPath = globalThis.location.pathname + globalThis.location.search;
            if (lastPath === '/preonboarding-forms'|| lastPath ==="/preonboarding-forms/success") {
                setTimeout(() => {
                    localStorage.removeItem("token");
                    localStorage.clear();
                    globalThis.location.replace("/email-verification", { replace: true });
                }, 1000);
            } else {
                setTimeout(() => {
                    localStorage.removeItem("token");
                    localStorage.clear();
                    globalThis.location.href = "/";
                }, 1000);
            }
            Store.dispatch(hideLoader());
            //return Promise.reject('no token available');
            throw new Error('No token available');
        }
        if (config.headers['custom-auth-type'] === 'token') {
            config.headers.Authorization = `${token}`;
        } else {
            // Default to Bearer token for all other requests
            config.headers.Authorization = `Bearer ${token}`;
        }
        config.headers["ngrok-skip-browser-warning"] = "true";
        return config;
    },
    async (err) => {
        const { Store } = await import("../../redux/Store");
        Store.dispatch(hideLoader());
        //return Promise.reject(err);
        throw err;
    }
);

// axiosPrivate.interceptors.response.use(
//     async (response) => {
//         const { Store } = await import("../../redux/Store");
//         Store.dispatch(hideLoader());
//         return response;
//     },
//     async (err) => {
//         if (err?.response?.status === 401 || err?.response?.status === 403) {
//             const lastPath = globalThis.location.pathname + globalThis.location.search;
//             if (lastPath === '/preonboarding-forms') {
//                 setTimeout(() => {
//                     localStorage.removeItem("token");
//                     localStorage.clear();
//                     globalThis.location.replace("/email-verification", { replace: true });
//                 }, 1000);
//             }
//             else {
//                 sessionStorage.setItem("last path", lastPath);
//                 localStorage.removeItem("token");
//                 localStorage.clear();
//                 globalThis.location.replace("/", { replace: true });
//             }

//             return;
//         }

//         const { Store } = await import("../../redux/Store");
//         Store.dispatch(hideLoader());
//         //return Promise.reject(err);
//         throw err;
//     }
// );

axiosPrivate.interceptors.response.use(
    async (response) => {
        const { Store } = await import("../../redux/Store");
        Store.dispatch(hideLoader());
        return response;
    },
    async (err) => {
        const { Store } = await import("../../redux/Store");
        Store.dispatch(hideLoader());
        if (!err.response) {
            toast.error(
                "Network error. Please check your internet connection.",
                { className: 'toast-error-custom' }
            );
            throw err;
        }

        const { status, data } = err.response;
        const lastPath = globalThis.location.pathname + globalThis.location.search;

        console.log("===HTTP Status====", status, data);
        const AUTH_ERROR_CODES = [
            "TOKEN_EXPIRED",
            "INVALID_TOKEN",
            "SESSION_EXPIRED",
            "UNAUTHORIZED",
            "AUTH_REQUIRED"
        ];
        if (status === 401 || (status === 403 && (!data?.code || AUTH_ERROR_CODES.includes(data.code)))
        ) {
            sessionStorage.setItem("last Path", lastPath);
            localStorage.clear();
            setTimeout(() => {
                if (lastPath === "/preonboarding-forms"|| lastPath ===  "/preonboarding-forms/success") {
                    globalThis.location.replace("/email-verification");
                } else {
                    globalThis.location.replace("/");
                }
            }, 1000);
            throw err;
        }
        if (status === 403 && data?.code === "PERMISSION_DENIED") {
            toast.error(
                data?.message || "You do not have permission to access this module",
                { className: 'toast-error-custom' }
            );
            throw err;
        }

        if (status >= 500) {
            toast.error(
                "Server error. Please try again later.",
                { className: 'toast-error-custom' }
            );
        }
        throw err;
    }
);

export default axiosPrivate;